export function validateCurrentSelectionsIncludeSourceSelections({
  questions,
  currentQuestion,
  isSourceQuestion,
  isCurrentQuestion,
  getSourceSelections,
  getCurrentSelections,
  normalizeSelection = (selection) => selection,
  getSelectionLabel = (selection) => selection,
  message,
  sourceSelections,
  currentSelections,
}) {
  if (!isCurrentQuestion(currentQuestion)) {
    return null;
  }

  const requiredSelections = new Set();
  const requiredSelectionLabels = {};

  if (sourceSelections) {
    sourceSelections.forEach((selection) => {
      const normalizedSelection = normalizeSelection(selection);

      if (normalizedSelection) {
        requiredSelections.add(normalizedSelection);
        if (!requiredSelectionLabels[normalizedSelection]) {
          requiredSelectionLabels[normalizedSelection] =
            getSelectionLabel(selection);
        }
      }
    });
  } else {
    questions.forEach((question) => {
      if (isSourceQuestion(question)) {
        getSourceSelections(question).forEach((selection) => {
          const normalizedSelection = normalizeSelection(selection);

          if (normalizedSelection) {
            requiredSelections.add(normalizedSelection);
            if (!requiredSelectionLabels[normalizedSelection]) {
              requiredSelectionLabels[normalizedSelection] =
                getSelectionLabel(selection);
            }
          }
        });
      }
    });
  }

  const selectedCurrentValues = currentSelections
    ? currentSelections
    : getCurrentSelections(currentQuestion, requiredSelections);

  const normalizedCurrentSelections = new Set(
    selectedCurrentValues
      .map((selection) => normalizeSelection(selection))
      .filter(Boolean)
  );

  const missingSelections = Array.from(requiredSelections).filter(
    (selection) => !normalizedCurrentSelections.has(selection)
  );

  if (missingSelections.length === 0) {
    return null;
  }

  const sourceSelectionLabels = Array.from(requiredSelections).map(
    (selection) => requiredSelectionLabels[selection] || selection
  );
  const missingSelectionLabels = missingSelections.map(
    (selection) => requiredSelectionLabels[selection] || selection
  );

  return {
    message:
      typeof message === "function"
        ? message({
            sourceSelections: sourceSelectionLabels,
            missingSelections: missingSelectionLabels,
          })
        : message,
    missingSelections: missingSelectionLabels,
    sourceSelections: sourceSelectionLabels,
  };
}
